import {Component} from '@angular/core';

@Component({
  selector: 'app-explanation-modal',
  templateUrl: './explanation-modal.component.html',
  styleUrls: ['./explanation-modal.component.css']
})
export class ExplanationModalComponent {}
